import { debug, observer, pr, React, ui } from "aaa";
import { pushRoute } from "stores/RouterFunctions";
import { history } from "stores/RouterStore";
import { ISigningResponse } from "types/signing";
import { numberToCurrencyString } from "util/helpers";
import { SigningComponent } from "../signing/views/SigningComponent";
import { TPPStore } from "./TPPStore";
import { TPPRoutes } from "./TPPRoutes";

type IProps = {
    store: TPPStore;
};

@observer
export class TPPSigning extends React.Component<IProps, {}> {
    render() {
        let signInfo = this.props.store.putAccountResponse?.signInfo;

        return (
            <SigningComponent
                useWebVersion
                signingInfo={signInfo}
                content={
                    <div>
                        <pr.SigningLabelContainer>
                            <pr.SigningLabelTitle>{ui.__("signing.action.label")}</pr.SigningLabelTitle>
                            <pr.SigningLabel>
                                {ui.__("tpp.signing.action.changeDefaultAccount")}
                            </pr.SigningLabel>
                            <br />

                            <pr.SigningLabelTitle>{ui.__("common.fees")}</pr.SigningLabelTitle>
                            <pr.SigningLabel>{ui.__("common.freeOfCharge")}</pr.SigningLabel>

                        </pr.SigningLabelContainer>
                    </div>
                }

                onSuccess={async (response: ISigningResponse) => {
                    debug.log("### signing success", response);
                    pushRoute(TPPRoutes.SUCCESS);
                    await this.props.store.load();
                }}

                onClose={async () => {
                    this.props.store.restoreOriginalDefaultAccount();
                    history.goBack();
                }}

                onRetry={async () => {
                    await this.props.store.updateDefaultAccount();
                }}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/tpp/TPPSigning.tsx